<template>
  <div :class="previewMode ? '' : 'wf-border wf-p-2 wf-pt-0 wf-border-transparent hover:wf-border-gray-500 hover-trigger'">
    <div v-show="! previewMode" class="wf-relative wf-justify-end wf-flex">
      <button class="hover-target pricing-table-block-handle wf-text-gray-500"><i class="fas fa-arrows-alt"></i></button>
    </div>
    <div :class="containerClasses">
      <div
        class="wf-inline-block"
        :class="classes"
        :style="styles"
        :contenteditable="! previewMode"
        v-text="value"
        @input="emitUpdate"
      ></div><span v-show="recurrency" class="wf-ml-1 wf-text-lg wf-text-gray-600" v-text="priceRecurrency"></span>  
    </div>
  </div>
</template>

<script>
  import PricingTableBlock from '../contracts/PricingTableBlock'
  export default PricingTableBlock.extend({
    props: {
      recurrency: {
        type: String,
        required: false,
      },
    },
    computed: {
      priceRecurrency() {
        let recurrencyTypes = {
          weekly: '/wk',
          monthly: '/mo',
          yearly: '/yr',
        }
        return recurrencyTypes[this.recurrency]
      },
    },
  })
</script>